// src/components/RequireAuth.tsx
import { Navigate, useLocation } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { authStore } from "../stores";
import { JSX } from "react";

const RequireAuth = observer(({ children }: { children: JSX.Element }) => {
  const location = useLocation();

  if (!authStore.loggedIn) {
    // 跳转到登录页面，并带上跳转前的路径（可选）
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
});

export default RequireAuth;
